<template>
  <el-collapse-item name="4">
    <template slot="title">
      Motoboy&nbsp;<el-tag>{{ tableList.length }}</el-tag>
    </template>
    <el-table :data="tableList" size="small" stripe>
      <el-table-column sortable prop="action" :label="$t('tipo')">
        <template slot-scope="scope">
          {{
            scope.row.action === 'save' ? 'Agrupado' : 'Solicitar'
          }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="type" :label="$t('servico')" />
      <el-table-column sortable prop="name" :label="$t('destinatario')" />
      <el-table-column sortable prop="sourceZipcode" :label="$t('cep-origem')" />
      <el-table-column sortable prop="destinyZipcode" :label="$t('cep-destino')" />
      <el-table-column sortable prop="value" :label="$t('valor')">
        <template slot-scope="scope">
          {{
            scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
          }}
        </template>
      </el-table-column>
      <el-table-column width="80" align="right">
        <template slot-scope="scope">
          <el-button type="danger" size="small" icon="el-icon-delete" @click.native.prevent="remove(scope.$index)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-collapse-item>
</template>

<script>
import { PdvService } from "@/services/pdv/pdv.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "PdvClosedMotoboy",
  computed: {
    tableList() {
      return this.tableData.filter(x => x.state === 'add');
    }
  },
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    clear() {
      this.tableData = [];
    },
    remove(index) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-motoboy"),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        vm.$bus.$emit("pdv.removed", vm.tableData[index]);
        vm.tableData[index].state = 'remove';
        this.$message({
          type: "success",
          duration: 5000,
          message: "Motoboy removida com sucesso!",
        });
      });
    },
    add(data) {
      this.tableData.push(data);
    },
  },
}
</script>